"use client";

import { AuthContext } from "@/context/auth-context";
import { useContext } from "react";

export default function LogoutButton() {
  const { logout, isLoggedIn } = useContext(AuthContext);
  return isLoggedIn ? (
    <div
      className="btn btn-ghost btn-md flex items-center justify-center h-full"
      onClick={() => {
        logout();
      }}
    >
      Logout
    </div>
  ) : null;
}
